import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import slipLogo from '../../assets/images/company/slip_logo.png'
import BBPSSidebarLogo from "../../assets/images/BBPSSidebarLogo.png"


const BBPSPrint3 = () => {
  const [printData, setPrintData] = useState(null);

  useEffect(() => {
    const data = localStorage.getItem("print");
    if (data) {
      setPrintData(JSON.parse(data));
    }
  }, []);

  const printReceipt = () => {
    const printContent = document.getElementById("receipt-content").innerHTML;
    const printWindow = window.open('', '', 'height=800,width=900');

    printWindow.document.write(`
    <html>
      <head>
        <title>Print Receipt</title>
        <style>
          body { font-family: -webkit-body, sans-serif; margin: 0; padding: 20px; }
         
         
          .printable-container {
            border: 1px solid #000;
            border-radius: 5px;
            padding: 1rem;
            margin: 20px;
          }
         
          .header-flex {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
            padding: 0 10px;
          }

          .card-style {
            border: 1px solid rgba(0,0,0,.125);
            border-radius: .25rem;
            margin: 10px;
            padding: 10px;
            background-color: #fff;
          }

          table {
            width: 100%;
            border: none;
            border-collapse: collapse;
          }

          td {
            padding: 8px 1rem;
            font-size: 1rem;
            width: 50%;
            vertical-align: top;
          }

          .footer-text {
            display: flex;
            font-size: 1rem;
            margin: 20px 10px 0;
            padding: 0 10px;
          }


          .hide-on-print { display: none; }
         
          * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
        </style>
      </head>
      <body>
        <div class="printable-container">
          ${printContent}
        </div>
      </body>
    </html>
  `);

    printWindow.document.close();

   
    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }, 700);
  };

  if (!printData) return <p style={{ padding: "20px" }}>Loading Data...</p>;

  return (
    <>

      <div
        id="receipt-content"
        style={{
          margin: "5vw",
          border: "1px solid #000",
          borderRadius: "5px",
          padding: "1rem",
        }}
      >
        <div>
          <div
            style={{
              margin: "0px 10px",
              padding: "0px 10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <img
              src={BBPSSidebarLogo}
              style={{
                width: "auto",
                height: "3.5rem",
              }}
            />
            <img
              src={slipLogo}
              style={{
                width: "auto",
                height: "3.5rem",
              }}
            />
          </div>
          <div>
            {printData && (
              <div className="card" style={{ margin: "10px", padding: "10px" }}>
                <table style={{ border: "none", fontFamily: "-webkit-body" }}>
                  <tr style={{ background: "none", border: "none" }}>
                    <td
                      style={{
                        paddingLeft: "1rem",
                        border: "none",
                        background: "none",
                        width: "50%",
                        fontSize: "1rem",
                      }}
                    >
                      {" "}
                      Shop Name
                    </td>
                    <td
                      style={{
                        paddingLeft: "1rem",
                        border: "none",
                        background: "none",
                        width: "50%",
                        fontSize: "1rem",
                      }}
                    >
                      {" "}
                      {printData.shopName}
                    </td>
                  </tr>
                  {
                    printData.params && printData.params.length > 0 && (
                      printData.params.map((param) => (
                        <tr style={{ background: "none" }}>
                          <td
                            style={{
                              paddingLeft: "1rem",
                              border: "none",
                              background: "none",
                              width: "50%",
                              fontSize: "1rem",
                            }}
                          >
                            {param.name}
                          </td>
                          <td
                            style={{
                              paddingLeft: "1rem",
                              border: "none",
                              background: "none",
                              width: "50%",
                              fontSize: "1rem",
                            }}
                          >
                            {" "}
                            {param.value}
                          </td>
                        </tr>
                      ))

                    )
                  }
                  <tr style={{ background: "none" }}>
                    <td
                      style={{
                        paddingLeft: "1rem",
                        border: "none",
                        background: "none",
                        width: "50%",
                        fontSize: "1rem",
                      }}
                    >
                      {" "}
                      Consumer Number
                    </td>
                    <td
                      style={{
                        paddingLeft: "1rem",
                        border: "none",
                        background: "none",
                        width: "50%",
                        fontSize: "1rem",
                      }}
                    >
                      {" "}
                      {printData.Name}
                    </td>
                  </tr>
                  <tr style={{ background: "none" }}>
                    <td
                      style={{
                        paddingLeft: "1rem",
                        border: "none",
                        background: "none",
                        width: "50%",
                        fontSize: "1rem",
                      }}
                    >
                      {" "}
                      Amount
                    </td>
                    <td
                      style={{
                        paddingLeft: "1rem",
                        border: "none",
                        background: "none",
                        width: "50%",
                        fontSize: "1rem",
                      }}
                    >
                      {"₹ "}
                      {printData.rch_amount}
                    </td>
                  </tr>

                  <tr style={{ background: "none" }}>
                    <td
                      style={{
                        paddingLeft: "1rem",
                        border: "none",
                        background: "none",
                        width: "50%",
                        fontSize: "1rem",
                      }}
                    >
                      {" "}
                      Provider
                    </td>
                    <td
                      style={{
                        paddingLeft: "1rem",
                        border: "none",
                        background: "none",
                        width: "50%",
                        fontSize: "1rem",
                      }}
                    >
                      {" "}
                      {printData.rch_operator_id}
                    </td>
                  </tr>


                  <tr style={{ background: "none" }}>
                    <td
                      style={{
                        paddingLeft: "1rem",
                        border: "none",
                        background: "none",
                        width: "50%",
                        fontSize: "1rem",
                      }}
                    >
                      {" "}
                      Status
                    </td>
                    <td
                      style={{
                        paddingLeft: "1rem",
                        border: "none",
                        background: "none",
                        width: "50%",
                        fontSize: "1rem",
                      }}
                    >
                      {" "}
                      {printData.rch_status_desc}
                    </td>
                  </tr>

                  <tr style={{ background: "none" }}>
                    <td
                      style={{
                        paddingLeft: "1rem",
                        border: "none",
                        background: "none",
                        width: "50%",
                        fontSize: "1rem",
                      }}
                    >
                      {" "}
                      Reference Id
                    </td>
                    <td
                      style={{
                        paddingLeft: "1rem",
                        border: "none",
                        background: "none",
                        width: "50%",
                        fontSize: "1rem",
                      }}
                    >
                      {" "}
                      {printData.refId}
                    </td>
                  </tr>

                  <tr style={{ background: "none" }}>
                    <td
                      style={{
                        paddingLeft: "1rem",
                        border: "none",
                        background: "none",
                        width: "50%",
                        fontSize: "1rem",
                      }}
                    >
                      {" "}
                      Recharge date
                    </td>
                    <td
                      style={{
                        paddingLeft: "1rem",
                        border: "none",
                        background: "none",
                        width: "50%",
                        fontSize: "1rem",
                      }}
                    >
                      {" "}
                      {printData.rch_indate}
                    </td>
                  </tr>



                </table>
              </div>
            )}
          </div>
        </div>

        <div style={{ display: "flex", fontSize: "1rem", margin: "0px 10px", padding: "0px 10px" }}>
          <strong> {`Visit us at : www.payments.bumppy.com`}</strong>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ flex: "1" }} />
          <button
            style={{ marginLeft: "auto" }}
            className="hide-on-print"
            onClick={printReceipt}
          >
            {"Print"}
          </button>
        </div>
      </div>
    </>
  );
};

export default BBPSPrint3;